module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/3@2x_ee132ef9dc353b0937923f2af3ba5959.png";